var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0305 2.26971C6.3155 2.26971 3.29633 5.29735 3.29633 9.02279V12.2755C3.29633 12.9621 3.00451 14.0088 2.65658 14.5941L1.36585 16.7438C0.568974 18.0719 1.11893 19.5463 2.57801 20.0416C7.41542 21.6623 12.6344 21.6623 17.4718 20.0416C18.8299 19.5914 19.4247 17.9819 18.684 16.7438L17.3933 14.5941C17.0566 14.0088 16.7647 12.9621 16.7647 12.2755V9.02279C16.7647 5.3086 13.7343 2.26971 10.0305 2.26971Z",
    fill: "#003DA5",
    stroke: "#003DA5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1071 2.59606C10.7498 2.20843 9.31161 2.20843 7.95435 2.59606C8.27983 1.76318 9.08794 1.17792 10.0307 1.17792C10.9735 1.17792 11.7816 1.76318 12.1071 2.59606Z",
    fill: "#003DA5",
    stroke: "#003DA5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.397 20.4455C13.397 22.3026 11.8819 23.822 10.0299 23.822C9.1096 23.822 8.2566 23.4394 7.65052 22.8316C7.01993 22.1983 6.66485 21.3405 6.66284 20.4455",
    fill: "#003DA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.397 20.4455C13.397 22.3026 11.8819 23.822 10.0299 23.822C9.1096 23.822 8.2566 23.4394 7.65052 22.8316C7.01993 22.1983 6.66485 21.3405 6.66284 20.4455",
    stroke: "#003DA5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueNotifications);
export default __webpack_public_path__ + "static/media/blueNotifications.badd498b4b561dd79d317da8f5bd9eda.svg";
export { ForwardRef as ReactComponent };